import { BtnAddOnTable, BtnEditOnTable, BtnViewOnTable } from "components/Button/ButtonTable";
import DataGrid, { PaginationInterface, initRows } from "components/DataGrid";
import React, { useEffect, useState } from "react";
import { FormProvider, useForm } from "react-hook-form";
import { useLocation, useNavigate } from "react-router";
import { FnAxios, FnDialog } from "utilities/utilities";
import { FilterFieldInterface } from "components/DataGrid/DataGridProps";
import { EnumStatus } from "../AdminUser/Role/RoleList";
import { Box, Chip, Grid, IconButton, Modal, Popover, Tooltip, Typography } from "@mui/material";
import InfoIcon from '@mui/icons-material/Info';
import { GetMenuPermission } from "utilities/SystemFunction";

const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 400,
    bgcolor: 'background.paper',
    border: '2px solid #000',
    boxShadow: 24,
    p: 4,
};

const HolidayManagement = () => {
    const DialogFn = FnDialog();
    const AxiosFn = FnAxios();
    const navigate = useNavigate();
    const location = useLocation();
    const [loadingTable, setLoadingTable] = useState(false);
    const [arrYear, setArrYear] = useState([]);
    const [isView, setisView] = useState(false);
    const [sUpdateName, setUpdateName] = useState(null);
    const [anchorEl, setAnchorEl] = React.useState(null);
    const [dataRow, setDataRow] = useState<PaginationInterface>({
        ...initRows,
        sSortExpression: "sUpdateDate",
        sSortDirection: "desc"
    });

    const [isPermission, setPermission] = useState<boolean>(false); // Permission

    useEffect(() => {
        GetMenuPermission(AxiosFn, setPermission, DialogFn);
    }, []);

    const form = useForm({
        shouldFocusError: false,
        mode: "all"
    });

    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    const open = Boolean(anchorEl);

    const getFormInitial = () => {
        AxiosFn.Post(`HolidayManagement/GetInitialHoliday`, {}, (result) => {
            setArrYear(result.objResult.lstYear);
        });
    }

    const getTable = (p: PaginationInterface) => {
        setLoadingTable(true);
        let param = {
            ...p
        }

        AxiosFn.Post(`HolidayManagement/GetTableHoliday`, param, (result) => {
            setLoadingTable(false);
            setDataRow({
                ...p,
                arrRows: result.lstHolidayManagement ?? [],
                nDataLength: result.ObjTable?.nDataLength,
                nPageIndex: result.ObjTable?.nPageIndex,
            });
        });
    };

    const handleDelete = (e) => {
        let param = {
            lstID: e,
            sLocation: location.pathname,
            nType: 1
        }

        DialogFn.Submit("คุณต้องการลบข้อมูลใช่หรือไม่ ?", () => {
            AxiosFn.Post(`HolidayManagement/OnDelete`, param, (result) => {
                if (result.nStatusCode === 200) {
                    DialogFn.Success("ลบสำเร็จ", () => {
                        getTable(dataRow);
                    });
                }
            });
        });
    }

    const handleEdit = (sID: string, item: any) => {
        navigate(`/HolidayManagementForm?sID=${encodeURI(sID)}`);
    }

    const handleViewInfo = (e) => {
        setUpdateName(e.sUpdateName);//sUpdateName
    }

    const dataColumn: any = [
        {
            renderHeader: (item) => {
                return (
                    <BtnAddOnTable
                        id={"addHoliday"}
                        onClick={() => { navigate(`/HolidayManagementForm`) }}
                        txt={"เพิ่มวันหยุด"}
                        IsDisabled={!isPermission}
                    />
                );
            },
            field: "ปุ่ม (เพิ่ม/แก้ไข)",
            align: "center",
            type: "actions",
            resizable: false,
            sortable: false,
            width: 60,
            getActions: (item) => {
                return [
                    <>
                        {isPermission ? (
                            <BtnEditOnTable
                                key={item.row.sID}
                                id={"editIndicatorYear"}
                                txt={"Edit"} //Edit
                                onClick={() => { handleEdit(item.row.sID, item.row) }}
                            />
                        ) : (
                            <BtnViewOnTable
                                key={item.row.sID}
                                id="btnView"
                                onClick={() => { handleEdit(item.row.sID, item.row) }}
                            />
                        )}
                    </>

                ];
            },
        },
        {
            field: 'nYearHoliday',
            headerName: 'ปี',
            headerAlign: 'center',
            minWidth: 260,
            sortable: true,
            flex: 1,
            align: "center"
        },
        {
            field: 'nHolidayCount',
            headerName: 'จำนวนวันหยุดพิเศษประจำปี',
            headerAlign: 'center',
            align: 'center',
            minWidth: 250,
            sortable: true,
            editable: false,
            flex: 1,
        },
        {
            field: 'sUpdateDate',
            headerName: 'แก้ไขล่าสุด',
            headerAlign: 'center',
            align: 'center',
            minWidth: 250,
            sortable: true,
            editable: false,
            flex: 1,
            renderCell: (item) => {
                return (
                    <>
                        <Grid sx={{ mr: "4px" }}>
                            {item.row.sUpdateDate}
                        </Grid>
                        <IconButton size="small"
                            onClick={(e) => { handleClick(e); handleViewInfo(item.row); }}
                        >
                            <InfoIcon
                                style={{ color: "#6e130d", cursor: "pointer" }}
                            />
                        </IconButton>
                    </>
                )
            }
        },
        {
            field: 'isActive',
            headerName: 'สถานะ',
            headerAlign: 'center',
            align: 'center',
            minWidth: 180,
            editable: false,
            sortable: true,
            flex: 1,
            renderCell: (item) => {
                return (
                    <>
                        {EnumStatus.Active == item.row.isActive &&
                            <Tooltip title={item.row.sStatus}>
                                <Chip
                                    size="medium"
                                    label={item.row.sStatus}
                                    style={{
                                        color: "rgb(22 187 68)",
                                        backgroundColor: "rgb(231 255 237)",
                                        margin: "0.2rem",
                                        fontSize: "0.8rem"
                                    }}
                                />
                            </Tooltip>
                        }
                        {EnumStatus.isActive == item.row.isActive &&
                            <Tooltip title={item.row.sStatus}>
                                <Chip
                                    size="medium"
                                    label={item.row.sStatus}
                                    style={{
                                        color: "#f1416c",
                                        backgroundColor: "#fff5f8",
                                        margin: "0.2rem",
                                        fontSize: "0.8rem"
                                    }}
                                />
                            </Tooltip>

                        }
                    </>
                )
            }
        },
    ];

    const filter: FilterFieldInterface[] = [
        { sTypeFilterMode: "multiselect", sLabel: "ปี", sFieldName: "lstYear", optionSelect: arrYear, nGridLG: 3, nGridMD: 3, nGridSM: 3, nGridXS: 12 },
        {
            sTypeFilterMode: "select", sLabel: "สถานะ", sFieldName: "sActive",
            optionSelect: [
                {
                    label: "ใช้งาน",
                    value: "1"
                },
                {
                    label: "ไม่ใช้งาน",
                    value: "0"
                },

            ],
            nGridLG: 2, nGridMD: 2, nGridSM: 2, nGridXS: 12
        },
    ];

    useEffect(() => {
        getFormInitial()
        getTable(dataRow)
    }, []);

    return (
        <React.Fragment>
            <FormProvider {...form}>
                <DataGrid
                    sTableID='HolidayManagement'
                    columns={dataColumn}
                    rows={dataRow}
                    modeFilter={1}
                    isLoading={loadingTable}
                    onLoadData={getTable}
                    isShowCheckBox={isPermission}
                    filterField={filter}
                    onDelete={handleDelete}
                />

                {/* pop over */}
                <Popover
                    id={`sUpdateNameHoliday`}
                    open={open}
                    anchorEl={anchorEl}
                    onClose={handleClose}
                    anchorOrigin={{
                        vertical: 'center',
                        horizontal: 'right',
                    }}
                    transformOrigin={{
                        vertical: 'top',
                        horizontal: 'left',
                    }}
                >
                    <Typography sx={{ p: 2 }}>{sUpdateName}</Typography>
                </Popover>
            </FormProvider>
        </React.Fragment>
    );
}

export default HolidayManagement;